import styled from '@emotion/styled';

import { COLORS, hex2rgba } from '../../styles';

export const Container = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  max-height: calc(100% - 30px);
  padding: 8px;
  writing-mode: vertical-lr;
  border-radius: 8px;
  background: ${COLORS.gray0};
  box-shadow: 0 0 0 1px ${COLORS.slategray10};
  z-index: 999;
  &:empty {
    display: none;
  }
`;

export const Button = styled.button`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    color: ${COLORS.slategray70};
    border: 0;
    border-radius: 8px;
    background: none;
    cursor: pointer;
    &:hover,
    &:active {
      color: ${COLORS.blue60};
      background: ${hex2rgba(COLORS.slategray10, 0.5)};
    }
    svg {
      width: 50%;
      height: 50%;
    }
  }
`;
